// ============================================================
// ARCHIVO DE DATOS EDITABLE — Cristián Díaz · IKONS
// Edita aquí: contacto, estadísticas, vídeos, fotos, valoración
// y fechas de actualización. Los textos ES/EN de la interfaz
// están en src/i18n/translations.js
// ============================================================

export const CONTACT = {
  agency: "IKONS",
  agentName: "Edgar Merino Vidangossy",
  agentRole: { es: "Agente FIFA", en: "FIFA Agent" },
  // EDITABLE: correo de contacto profesional de IKONS
  email: "merinovidangossy@gmail.com",
  // EDITABLE: teléfono de contacto (dejar "" para ocultarlo)
  phone: "+34 665 497 561",
};

export const PLAYER = {
  name: "CRISTIÁN DÍAZ FERRADA",
  fullName: "Cristián Antonio Díaz Ferrada",
  age: 23,
  club: "Deportes Antofagasta",
  country: "Chile",
};

export const CONTRACT = {
  until: "31/12/2026",
  freeAgentFromYear: 2027,
};

export const STATS = {
  // EDITABLE: fecha de corte y fuente de partidos/minutos/goles
  // Actualizado por el usuario el 24/10/2026 (fuente: Transfermarkt)
  cutOff: { es: "24/10/2026", en: "24/10/2026" },
  source: {
    es: "Transfermarkt",
    en: "Transfermarkt",
  },
  sourceUrl: "https://www.transfermarkt.es/cristian-diaz/leistungsdaten/spieler/953173/plus/1",
  liga: {
    competition: { es: "Liga de Ascenso", en: "Liga de Ascenso" },
    season: "2026",
    matches: 26,
    minutes: 2156,
    goals: 2,
    assists: 1,
  },
  copa: {
    competition: { es: "Copa Chile", en: "Copa Chile" },
    season: "2026",
    matches: 5,
    minutes: 364,
    goals: 0,
  },
  // Total 2026 tal como lo publica la fuente (no es una suma propia)
  total2026: { matches: 31, minutes: 2520, goals: 2 },
  // Carrera profesional en Deportes Antofagasta según Transfermarkt (todas las competiciones)
  career: { matches: 130, minutes: 10286, goals: 6 },
  // Métricas defensivas: proceden del informe de la representación (IKONS), corte junio 2026.
  // No están disponibles públicamente para verificación independiente.
  defensive: {
    interceptions: 38,
    blockedShots: 13,
    source: { es: "Informe IKONS · jun. 2026", en: "IKONS report · Jun 2026" },
  },
  // Dato reportado por la representación, sin fuente de medición independiente
  topSpeedKmh: 34,
};

export const VIDEOS = [
  {
    id: "1085378468",
    hash: "bd30949843",
    poster: "/images/night-home.jpg",
    title: {
      es: "Defensa central",
      en: "Centre-back",
    },
  },
  {
    id: "1137785373",
    hash: "fece600d38",
    poster: "/images/away-purple.jpg",
    title: {
      es: "Medio defensivo",
      en: "Defensive midfielder",
    },
  },
  {
    id: "1197506553",
    hash: "82c97c607a",
    poster: "/images/action-home.webp",
    title: {
      es: "Mitad temporada 2026",
      en: "Mid-season 2026",
    },
  },
];

// Punto focal de cada foto (posición del rostro) para que nunca quede fuera del recorte.
// Formato CSS object-position: "x% y%". Ajustar si se cambian las imágenes.
export const PHOTO_FOCUS = {
  "/images/action-home.webp": "55% 22%",
  "/images/away-purple.jpg": "50% 18%",
  "/images/night-home.jpg": "45% 10%",
  "/images/portrait-standing.webp": "50% 28%",
  "/images/training.jpg": "50% 14%",
};

export const photoFocus = (src) => PHOTO_FOCUS[src] || "50% 20%";

export const PHOTOS = {
  hero: {
    src: "/images/action-home.webp",
    alt: {
      es: "Cristián Díaz controla el balón durante un partido con Deportes Antofagasta",
      en: "Cristián Díaz controls the ball during a match for Deportes Antofagasta",
    },
  },
  portrait: {
    src: "/images/portrait-standing.webp",
    alt: {
      es: "Cristián Díaz en el campo con la camiseta de Deportes Antofagasta",
      en: "Cristián Díaz on the pitch wearing the Deportes Antofagasta shirt",
    },
  },
  gallery: [
    {
      src: "/images/night-home.jpg",
      alt: {
        es: "Cristián Díaz conduce el balón en un partido nocturno con Deportes Antofagasta",
        en: "Cristián Díaz carries the ball in a night match for Deportes Antofagasta",
      },
    },
    {
      src: "/images/away-purple.jpg",
      alt: {
        es: "Cristián Díaz golpea el balón con la camiseta alternativa de Deportes Antofagasta",
        en: "Cristián Díaz strikes the ball in the Deportes Antofagasta away kit",
      },
    },
    {
      src: "/images/action-home.webp",
      alt: {
        es: "Cristián Díaz controla el balón durante un partido con Deportes Antofagasta",
        en: "Cristián Díaz controls the ball during a match for Deportes Antofagasta",
      },
    },
    {
      src: "/images/training.jpg",
      alt: {
        es: "Cristián Díaz en una sesión de entrenamiento de Deportes Antofagasta",
        en: "Cristián Díaz at a Deportes Antofagasta training session",
      },
    },
    {
      src: "/images/portrait-standing.webp",
      alt: {
        es: "Cristián Díaz en el campo con la camiseta de Deportes Antofagasta",
        en: "Cristián Díaz on the pitch wearing the Deportes Antofagasta shirt",
      },
    },
  ],
};

export const MARKET = {
  // EDITABLE: valoración y fecha según Transfermarkt
  value: "€250.000",
  updated: "22/06/2026",
  url: "https://www.transfermarkt.es/cristian-diaz/profil/spieler/953173",
};

// EDITABLE: reconocimiento público con fuente y fecha de publicación
export const RECOGNITION = {
  rank: "01",
  score: "0.905",
  minutesPct: { es: "92,6%", en: "92.6%" },
  source: "Data Ficus",
  sourceDescription: {
    es: "cuenta especializada en scouting y análisis",
    en: "specialist scouting & analysis account",
  },
  published: "10/10/2026",
  image: "/images/ranking-dataficus.jpg",
};

// EDITABLE: fecha de última actualización del sitio
export const SITE_UPDATED = { es: "octubre de 2026", en: "October 2026" };
